var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full flex items-center justify-center"},[_c('vs-chip',{attrs:{"color":_vm.value == 1 ? 'success' : 'danger'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }